import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {QueryProvider} from '@shared/queries/query-provider';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import {ParticleCacheModel} from "@shared/models/particle-cache.model";

@Component({
    standalone: false,
    selector: 'particle-start-demo',
  templateUrl: './start-demo.component.html',
  styleUrls: ['./start-demo.component.scss']
})
export class StartDemoComponent implements OnInit, OnDestroy, IDialogView {
  formGroup: FormGroup;
  data: DialogModel;
  private ngUnsubscribe = new Subject<void>();
  comment: string;
  demos$: any;
  demo: any;
  constructor(private queryState: Store<IQueryState>,
              private formBuilder: FormBuilder,
              private particleCacheService: ParticleCacheService,
  ) {

  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      demo : [this.demo, Validators.required],
      comment : ['', Validators.required]
    });
    this.demos$ = this.queryState.pipe(select(getQueryResponse, 'DemoConfig'));
    this.demos$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(demos => {
      if (demos && demos.length) {
        demos.forEach((item)=>{
          const toolTipCacheKey = `tool-tip-${item.companyId}`;
          this.particleCacheService.clearItem([toolTipCacheKey]);

          if(item.tooltips && item.tooltips.length){
            let toolTips = {};
            item.tooltips.forEach((toolTip)=>{
              toolTips[`${toolTipCacheKey}-${toolTip.key}`] = toolTip;
              //this.particleCacheService.saveItem("tool-tip-"+item.companyId +"-"+ toolTip.key, toolTip);
            });
            const toolTipCaches: ParticleCacheModel = {
              type   : toolTipCacheKey,
              value  : toolTips,
              version: '0.0.0'
            };
            this.particleCacheService.saveItem(toolTipCacheKey, toolTipCaches);
          }
        });
        this.demo = demos[0];
        this.formGroup.controls['demo'].setValue(this.demo);
      }
    });

    QueryProvider.invokeQuery(this.queryState, 'DemoConfig', {});
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onOkClicked() {
    this.data.input['selectedDemo'] = this.formGroup.controls['demo'].value;
    this.data.input['comment'] = this.formGroup.controls['comment'].value;
    return true;
  }
}
